// components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const isTokenValid = (token) => {
  if (!token) return false;
  
  try {
    // JWT is three base64 parts separated by dots
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    
    // Decode the payload (middle part)
    const payload = JSON.parse(atob(parts[1]));
    
    // Check expiry — exp is in seconds, Date.now() is milliseconds
    if (!payload.exp) return false;
    if (payload.exp * 1000 < Date.now()) {
      // Token expired — clean up localStorage
      localStorage.removeItem('auth_token');
      localStorage.removeItem('email');
      return false;
    }
    
    return true;
  } catch {
    // Malformed token
    return false;
  }
};

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('auth_token');
  
  if (!isTokenValid(token)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;